import { render, staticRenderFns } from "./parent-route.vue?vue&type=template&id=09e24f2a"
import script from "./parent-route.vue?vue&type=script&lang=js"
export * from "./parent-route.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports